import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";
import deleteIcon from '../../assets/images/deleteIcon_drawer.svg';
import locationIcon from "../../assets/images/location.svg";
import { deleteVisitLocation } from "../../actions/userActions/VisitProfileAction";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import { toast } from 'react-toastify';
import Heading6Semibold from "../designSystem/Heading6Semibold";
import BodyMediumRegular from "../designSystem/BodyMediumRegular";
import SingleSelect from "../designSystem/SingleSelect";
import { error } from "jquery";
import MultiSelect from "../designSystem/MultiSelect";

import practicelocationicon from "../../assets/images/practicelocationicon.svg";
import { getPracticeLocations } from "../../actions/userActions/practiceLocationAction";
import AddNewForm from "../addNew/AddNewForm";
import AddNewDrawer from "../addNew/AddNewDrawer";

import { t } from "../../locales/translate";
import "../reuse_components/LocationFieldsTile.css";
import { MapPin } from "lucide-react";

const practiceLocationPin = (location) => {
    const lat = location?.latitude ?? location?.Latitude;
    const lng = location?.longitude ?? location?.Longitude;
    if (lat == null || lng == null) return undefined;
    return (
        <MapPin
            size={18}
            color="var(--ff-success)"
            strokeWidth={2.5}
            className="task-practice-location-pin"
            aria-hidden
        />
    );
};

function VisitlocationsRow(props) {
    const TERRITORY_ENABLED = false; 
    const [openModal, setOpenModal] = useState(false);
    const [rowIndexToDelete, setRowIndexToDelete] = useState(null);
    const dispatch = useDispatch();
    const [drawerOpen, setDrawerOpen] = useState(false);
      const [drawerItem , setDrawerItem] = useState(null);
        const [drawerLoading, setDrawerLoading] = useState(false);
    const [cachedPracticeOptions, setCachedPracticeOptions] = useState([]);
    const [cachedDoctorOptions, setCachedDoctorOptions] = useState([]);

    const originallySelectedDoctorIdsRef = useRef(
        props.isUpdateMode ? (props.row?.doctors || []).map(String) : []
    );
    const originalPracticeLocationRef = useRef(props.row?.practiceLocation);

    const isDoctorActive = (doctor) => {
        if (typeof doctor?.active === "boolean") return doctor.active;
        if (typeof doctor?.isActive === "boolean") return doctor.isActive;
        return true;
    };

    const toDoctorOptions = (doctors) => {
        const originalIds = originallySelectedDoctorIdsRef.current;
        const samePracticeLocation =
            String(props.row?.practiceLocation || "") === String(originalPracticeLocationRef.current || "");
        return (doctors || [])
            .filter((doctor) => {
                if (isDoctorActive(doctor)) return true;
                return Boolean(
                    props.isUpdateMode &&
                    samePracticeLocation &&
                    originalIds.includes(String(doctor.id))
                );
            })
            .map((doctor) => ({
                value: doctor.id,
                label: doctor.name,
                subtext: doctor.specializationName || ""
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    };

    useEffect(() => {
        if (!TERRITORY_ENABLED) {
             setCachedPracticeOptions([]);
        }
        if (props.visitProfileData && props.visitProfileData !== "isLoading" && props.visitProfileData.result) {
            const locations = [];
            const addedIds = new Set();

            props.visitProfileData.result.forEach(profile => {
                profile.visitLocations.forEach(visitLoc => {
                    const location = visitLoc.practiceLocation;
                    if (!addedIds.has(location.id)) {
                        addedIds.add(location.id);
                        const pin = practiceLocationPin(location);
                        locations.push({
                            value: location.id,
                            label: location.name,
                            subtext: location.typeName && location.address ?
                                `${location.typeName} - ${location.address}` :
                                (location.typeName || location.address || ""),
                            ...(pin ? { secondaryLabel: pin } : {}),
                        });
                    }
                });
            });

            setCachedPracticeOptions(locations.sort((a, b) => a.label.localeCompare(b.label)));

            const selectedPracticeLocation = props.row?.practiceLocation;
            if (selectedPracticeLocation) {
                let doctors = [];
                props.visitProfileData.result.forEach(profile => {
                    profile.visitLocations.forEach(visitLoc => {
                        if (String(visitLoc.practiceLocation.id) === String(selectedPracticeLocation)) {
                            doctors = toDoctorOptions(visitLoc.practiceLocation.doctors);
                        }
                    });
                });
                setCachedDoctorOptions(doctors);
            }
        }
    }, [props.visitProfileData, props.row?.practiceLocation, props.isUpdateMode, ...(TERRITORY_ENABLED ? [] : [props.cityId])]);
    const handleRowChange = (rowIndex, field, value) => {
        if (field === "practiceLocation") {
            const locationAlreadyExists = props.formValues.rows.some(
                (row, index) => index !== rowIndex && row.practiceLocation === value
            );

            if (locationAlreadyExists) {
                toast.error("This practice location already exists in another row.");
                return;
            }
            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.map((row, index) =>
                    index === rowIndex ? { ...row, doctors: [] } : row
                ),
            }));
        }
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.map((row, index) =>
                index === rowIndex
                    ? {
                        ...row,
                        [field]:
                            field === "doctors"
                                ? [...(row[field] || []), value]
                                : value,
                    }
                    : row
            ),
        }));
    };
    const handleDeleteClick = (rowIndex) => {
        const row = props.formValues.rows[rowIndex];
        if (row.visitLocationId) {
            setRowIndexToDelete(rowIndex);
            setOpenModal(true);
        } else {
            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.filter((_, index) => index !== rowIndex),
            }));
        }
    };

    const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
      setDrawerOpen(true);
    };
    
    const handleConfirmDelete = async () => {
        const visitProfile = props.formValues.rows[rowIndexToDelete];
        try {
            await dispatch(deleteVisitLocation(visitProfile.visitLocationId));
            props.setFormValues((prevState) => ({
                ...prevState,
                rows: prevState.rows.filter((_, index) => index !== rowIndexToDelete),
            }));
        } catch (error) {
            console.error("Error while deleting:", error);
        } finally {
            setOpenModal(false);
        }
    };
    
    const handleCancelDelete = () => {
        setOpenModal(false);
    };
    const handleMultiSelectRowChange = (rowIndex, values) => {
        props.setFormValues((prevState) => ({
            ...prevState,
            rows: prevState.rows.map((row, index) =>
                index === rowIndex
                    ? {
                        ...row,
                        doctors: values
                    }
                    : row
            ),
        }));
    };
    const handleDeleteDoctor = (doctorId) => {
        const updatedDoctors = props.row.doctors.filter((doctor) => doctor !== doctorId);
        handleRowChange(props.index, "doctors", updatedDoctors);
    };

    const getOptions = (type) => {
    if (type === "practiceLocations") {
        const selectedValue = TERRITORY_ENABLED
        ?props.selectedTerritoryId
        :props.formValues?.city;
         //if (!props.isUpdateMode && !props.selectedTerritoryId) //enabled for enable territory and below 
        if (!props.isUpdateMode && !selectedValue) {
            return [{ value: 'no-data', label: 'No data', disabled: true }];
        }

        if (props.isVisitProfileDataLoading && cachedPracticeOptions.length > 0) {
            return cachedPracticeOptions;
        }

        if (props.isVisitProfileDataLoading) {
            return [{ value: props.row?.practiceLocation || 'loading', label: 'Loading...', disabled: true }];
        }

        const hasTerritoryFilter = TERRITORY_ENABLED && !!props.selectedTerritoryId;
        const allowedPracticeLocationIds = new Set(
            (props.allowedPracticeLocationIds || []).map((id) => String(id))
        );

        if (
            props.visitProfileData &&
            props.visitProfileData !== "isLoading" &&
            props.visitProfileData.result
        ) {
            const locations = [];
            const addedIds = new Set();
            props.visitProfileData.result.forEach(profile => {
                profile.visitLocations.forEach(visitLoc => {
                    const location = visitLoc.practiceLocation;
                    if (
                        TERRITORY_ENABLED &&
                        hasTerritoryFilter &&
                        !allowedPracticeLocationIds.has(String(location.id))
                    ) {
                        return;
                    }
                    if (!addedIds.has(location.id)) {
                        addedIds.add(location.id);
                        const pin = practiceLocationPin(location);
                        locations.push({
                            value: location.id,
                            label: location.name,
                            subtext: location.typeName && location.address ?
                                `${location.typeName} - ${location.address}` :
                                (location.typeName || location.address || ""),
                            ...(pin ? { secondaryLabel: pin } : {}),
                        });
                    }
                });
            });
            
            if (locations.length === 0) {
                return [{ value: 'no-data', label: 'No data', disabled: true }];
            }
            
            return locations.sort((a, b) => a.label.localeCompare(b.label));
        }
        return cachedPracticeOptions.length > 0 ? cachedPracticeOptions : [{ value: 'no-data', label: 'No data', disabled: true }];
    }
    
    if (type === "doctors") {
        if (!props.row.practiceLocation) {
            return [];
        }

        if (props.isVisitProfileDataLoading && cachedDoctorOptions.length > 0) {
            return cachedDoctorOptions;
        }

        if (props.isVisitProfileDataLoading) {
            return [{ value: 'loading', label: 'Loading...', disabled: true }];
        }
        
        if (
            props.visitProfileData &&
            props.visitProfileData !== "isLoading" &&
            props.visitProfileData.result
        ) {
            let doctors = [];
            props.visitProfileData.result.forEach(profile => {
                profile.visitLocations.forEach(visitLoc => {
                    if (String(visitLoc.practiceLocation.id) === String(props.row.practiceLocation)) {
                        doctors = toDoctorOptions(visitLoc.practiceLocation.doctors);
                    }
                });
            });
            
            return doctors;
        }
        return cachedDoctorOptions;
    }
    
    return [];
};

    return (
        <>
            <div key={`${props.row.practiceLocation}-${props.index}`} className={`mb-3 location-fields-row ${props.index > 0 ? 'has-delete' : 'no-delete'}`}>
                <div className="location-fields-tile">
                    <div className="row align-items-center">
                        <div className="col-6">
                            <SingleSelect
    label= {`${t("practiceLocation")} *`}
    isSearchable
    secondaryLabel
    iconEnd
    error={props.formErrors?.rows?.[props.index]?.practiceLocation}
    onChange={(e) => {
        if (e.value !== 'loading' && e.value !== 'no-data') {
            handleRowChange(props.index, "practiceLocation", e.value);
        }
    }}
    value={props.row.practiceLocation}
    placeholder={t("practiceLocation")}
    options={getOptions("practiceLocations")}
    configKey={"practiceLocation"}
    onAddNewClick={() => handleAddNew("practiceLocation")}
/>

                        </div>
                        <div className="col-6">
                            <MultiSelect
    label={`${t("doctor")} *`}
    isSearchable
    secondaryLabel
    iconEnd
    error={props.formErrors?.rows?.[props.index]?.doctors}
    onChange={(values) => {
        const filteredValues = values.filter(
            v => v !== 'loading' && v !== 'no-data' && v !== 'select-location'
        );
        if (filteredValues.length > 0 || values.length === 0) {
            handleMultiSelectRowChange(props.index, filteredValues);
        }
    }}
    value={props.row.doctors}
    placeholder={t("doctor")}
    options={getOptions("doctors")}
    
/>
                        </div>
                    </div>
                    {props.index > 0 && (
                        <div className="location-fields-remove-icon">
                            <IconButton onClick={() => handleDeleteClick(props.index)}>
                                <img src={deleteIcon} alt="Delete" />
                            </IconButton>
                        </div>
                    )}
                </div>
            </div>


            {openModal && (
                <div className="custom-modal">
                    <div className="custom-modal-content delete-location-modal">
                        <div className="modal-img">
                            <img src={locationIcon} alt="Location Icon" className="modal-icon" />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Delete Location' />
                            <BodyMediumRegular
                                color='#637381'
                                text='This practice location along with all the doctors will be deleted and plans created against these doctors will be affected.
                        Are you sure you want to delete?'
                                textAlign='center'
                            />
                        </div>

                        <div className="modal-buttons">
                            <CancelButton onClick={handleCancelDelete} text="Cancel" />
                            <PrimaryButton onClick={handleConfirmDelete} text="Delete" color="#C81E1E" />

                        </div>
                    </div>
                </div>
            )}
              <AddNewDrawer
          open={drawerOpen}
                    onClose={() => {
                        setDrawerOpen(false);
                        setDrawerLoading(false);
                    }}
          title={`Add ${drawerItem  ? drawerItem .charAt(0).toUpperCase() + drawerItem .slice(1) : ""}`}
          subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
          icon={drawerItem  === "practiceLocation" ? <img src={practicelocationicon} alt={drawerItem } /> : null}
                    loading={drawerLoading}
        >
          {drawerItem  && (
           <AddNewForm
              itemName={drawerItem }
                            onClose={() => {
                                setDrawerOpen(false);
                                setDrawerLoading(false);
                            }}
                            onLoadingChange={setDrawerLoading}
              onSave={(newData) => {
               if (drawerItem === "practiceLocation") {
                         dispatch(getPracticeLocations()).then(() => {
                           setFormValues((prev) => ({
                             ...prev,
                             practiceLocationId: newData.id,
                             practiceLocationName: newData.name
                           }));
                         });
                       }
              }}
            />

          )}
</AddNewDrawer>
        </>
    );
}
export default VisitlocationsRow;
